import { useRequest } from "hooks";
import type { ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { WaMessagesSetupsResponse, WaMessageSetup } from "../types";
import {
    getWaMessagesSetupsThunk,
    createWaMessagesSetupThunk,
    updateWaMessagesSetupThunk
} from "../thunks";
import { changeExportWaMessagesSetupsLoading as changeExportLoading } from "../slice";

export const useWaMessagesSetupsActions = () => {
    const getWaMessagesSetups = useRequest<
        ThunkReturnType<WaMessagesSetupsResponse>,
        string | undefined
    >({
        thunk: getWaMessagesSetupsThunk
    });

    const createWaMessagesSetup = useRequest<
        ThunkReturnType<ResourceResponse<WaMessageSetup>>,
        Partial<WaMessageSetup>
    >({
        thunk: createWaMessagesSetupThunk,
        shouldNotifyOnSuccess: true
    });

    const updateWaMessagesSetup = useRequest<
        ThunkReturnType<ResourceResponse<WaMessageSetup>>,
        Partial<WaMessageSetup>
    >({
        thunk: updateWaMessagesSetupThunk,
        shouldNotifyOnSuccess: true
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetWaMessagesSetups
    });

    return {
        getWaMessagesSetups,
        createWaMessagesSetup,
        updateWaMessagesSetup,
        downloadCsv
    };
};

export default useWaMessagesSetupsActions;
